import {TickarooLiveblogElement} from "./TickarooLiveblogElement";
import {TickarooLiveblogTeaserElement} from "./TickarooLiveblogTeaserElement";
import {TickarooLiveblogPortalElement} from "./TickarooLiveblogPortalElement";

export function startCustomElementSetup() {

  if(!customElements.get('tickaroo-liveblog')){
    window.customElements.define("tickaroo-liveblog", TickarooLiveblogElement)
  }

  if(!customElements.get('tickaroo-liveblog-teaser')){
    window.customElements.define("tickaroo-liveblog-teaser", TickarooLiveblogTeaserElement)
  }

  if(!customElements.get('tickaroo-liveblog-portal')){
    window.customElements.define("tickaroo-liveblog-portal", TickarooLiveblogPortalElement)
  }
}
